import React from 'react';
import { RoutePaths } from 'constant';
import { useTranslate } from 'hooks/use-translation';
import { InlineButton } from './components';

const viewTimesheet = () => {
  window.open(RoutePaths.timesheets);
};

export const viewTimesheetButton = (
  translate: ReturnType<typeof useTranslate>,
) => (
  <InlineButton onClick={viewTimesheet}>
    {translate('task.add_time_entry.view_timesheet')}
  </InlineButton>
);
